module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-con",
    attrs: {
      "id": "NavCon"
    }
  }, [_c('div', {
    staticClass: "nav",
    attrs: {
      "id": "Nav"
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "nav-list"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Service'
      },
      "active-class": "nav-router-link-active",
      "exact": ""
    }
  }, [_vm._v("服务介绍")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Scene'
      },
      "active-class": "nav-router-link-active"
    }
  }, [_vm._v("使用场景")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Flow'
      },
      "active-class": "nav-router-link-active"
    }
  }, [_vm._v("接入流程")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'ApiDoc'
      },
      "active-class": "nav-router-link-active"
    }
  }, [_vm._v("API文档")])], 1), _vm._v(" "), _c('li', {
    staticClass: "contact-us"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Flow',
        params: {
          anchor: 'contact'
        }
      },
      "active-class": "nav-router-link-none"
    }
  }, [_vm._v("立即合作")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('div', {
    staticClass: "logo"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c79fd2ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GlobalNav.vue
// module id = 16
// module chunks = 5